import { render, staticRenderFns } from "./AssigneeSearch.vue?vue&type=template&id=5bf6ae15"
import script from "./AssigneeSearch.vue?vue&type=script&lang=ts"
export * from "./AssigneeSearch.vue?vue&type=script&lang=ts"
import style0 from "./AssigneeSearch.vue?vue&type=style&index=0&id=5bf6ae15&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports